export const RPMHero = (function () {
	'use strict';

	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function init() {
		document.querySelectorAll('.rpmblock--hero').forEach(setup);
	}

	/**
	 * Crossfade: the next slide fades in on top of the current one (which stays visible underneath),
	 * so there's never a dip to the background color between images.
	 */
	function setup(hero) {
		clearTimeout(hero._heroTimer); // re-init safe (block editor previews)

		const slides = hero.querySelectorAll('.rpmblock--hero__slide');
		if (slides.length < 2 || reduceMotion.matches) return;

		const holdMs = (parseFloat(hero.dataset.slideDuration) || 6) * 1000;
		const fadeMs = (parseFloat(hero.dataset.fadeDuration) || 1.5) * 1000;
		let current = 0;

		const schedule = (delay) => {
			hero._heroTimer = setTimeout(next, delay);
		};

		function next() {
			// pause while the tab is hidden or the hero is removed (editor)
			if (!hero.isConnected) return;
			if (document.hidden) return schedule(1000);

			const prev = slides[current];
			const nextIndex = (current + 1) % slides.length;
			const img = slides[nextIndex].querySelector('img');

			whenReady(img).then(() => {
				slides.forEach((s) => s.classList.remove('is-prev'));
				prev.classList.replace('is-active', 'is-prev');
				slides[nextIndex].classList.add('is-active');
				current = nextIndex;

				// drop the old slide once the new one has fully faded in
				setTimeout(() => prev.classList.remove('is-prev'), fadeMs);
				schedule(holdMs + fadeMs);
			});
		}

		schedule(holdMs);
	}

	// resolve once the (possibly lazy) image is loaded and decoded, so the fade is smooth
	function whenReady(img) {
		if (!img) return Promise.resolve();
		img.loading = 'eager';
		if (img.complete && img.naturalWidth) return img.decode ? img.decode().catch(() => {}) : Promise.resolve();

		return new Promise((resolve) => {
			img.addEventListener('load', () => resolve(img.decode ? img.decode().catch(() => {}) : null), { once: true });
			img.addEventListener('error', resolve, { once: true });
		});
	}

	return {
		init: init,
	};
})();
